import { useCallback } from "react";
import { useZones } from "features/Responder/features/Zones";
import {
  estimateChildSeedSizeMeters,
  normalizePolygon,
  seedShapePoints,
} from "features/Responder/features/Zones";
import { useResponderMap } from "features/Responder/features/ResponderMap/contexts/ResponderMapContext";

export function useZonesActions() {
  const { addZone, updateZone, setActiveZoneId, zonesWithMeta } = useZones();
  const { setSelectedZoneIds } = useResponderMap();

  const addZoneAt = useCallback(
    (latlng, shape = "square", options = {}) => {
      if (!latlng) return;
      const parentId = options?.parentId ?? null;
      const parentZone =
        parentId != null
          ? zonesWithMeta.find((zone) => `${zone?.id}` === `${parentId}`) || null
          : null;
      const parentPoints = normalizePolygon(
        Array.isArray(parentZone?._points) ? parentZone._points : parentZone?.polygon || []
      );
      const derivedSizeMeters = Number.isFinite(Number(options?.sizeMeters))
        ? Number(options?.sizeMeters)
        : estimateChildSeedSizeMeters(parentPoints, 0.5, 60);
      const seed = seedShapePoints(latlng, shape, derivedSizeMeters);
      const id = addZone({
        name: "New Zone",
        polygon: seed,
        fillOpacity: 0.15,
        fillColor: "#f97316",
        strokeColor: "#f97316",
        parentId: parentZone?.id ?? null,
      });
      if (id != null) {
        setActiveZoneId?.(id);
        setSelectedZoneIds?.((prev = []) => {
          const next = new Set(prev.map((p) => `${p}`));
          next.add(id);
          return Array.from(next);
        });
      }
    },
    [addZone, setActiveZoneId, setSelectedZoneIds, zonesWithMeta]
  );

  const updateZoneGeometry = useCallback(
    (id, points) => {
      if (!id || !Array.isArray(points)) return;
      updateZone(id, { polygon: points });
    },
    [updateZone]
  );

  return {
    addZoneAt,
    updateZoneGeometry,
  };
}

export default useZonesActions;


